import React from 'react'

import { Portlet, Button, Table, Row, Col } from '_zari/core'

import NuevaDireccionModal from './modals/nuevo'
import EditarDireccionModal from './modals/editar'

const DireccionesSection = ({ direcciones, dispatch }) => {
  const editarData = React.useRef({})

  const [mostrarNuevaDireccionModal, setMostrarNuevaDireccionModal] = React.useState(false)

  const [mostrarEditarDireccionModal, setMostrarEditarDireccionModal] = React.useState(false)

  const agregarDireccionHandler = payload => {
    dispatch({ type: 'agregar', payload })
    setMostrarNuevaDireccionModal(false)
  }

  const actualizarDireccionHandler = payload => {
    dispatch({ type: 'actualizar', payload })
    setMostrarEditarDireccionModal(false)
  }

  const editarDireccionClickHandler = ({ _idFila }) => {
    const filas = direcciones.filter(row => row._idFila === _idFila)
    editarData.current = filas[0]
    setMostrarEditarDireccionModal(true)
  }

  const eliminarDireccionHandler = ({ _idFila }) => {
    dispatch({ type: 'eliminar', payload: { _idFila } })
  }

  return (
    <>
      <Portlet>
        <Portlet.Body noPadding>
          <Row>
            <Col md={12} className='mb-2 text-right'>
              <Button onClick={e => setMostrarNuevaDireccionModal(true)}>Nuevo</Button>
            </Col>
          </Row>
          <Table.ClientSide
            headRows={[{ label: 'DIRECCIÓN' }, { label: '' }]}
            filas={direcciones}
            rowTemplate={row => (
              <Table.Row hover key={row._idFila}>
                <Table.Cell>{row.direccion || '--'}</Table.Cell>
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item
                        key='editar'
                        handleClose={handleClose}
                        onClick={e => editarDireccionClickHandler({ _idFila: row._idFila })}
                      >
                        Editar
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item
                        key='eliminar'
                        handleClose={handleClose}
                        onClick={e => eliminarDireccionHandler({ _idFila: row._idFila })}
                      >
                        Eliminar
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarNuevaDireccionModal && (
        <NuevaDireccionModal
          handleClose={e => setMostrarNuevaDireccionModal(false)}
          show={mostrarNuevaDireccionModal}
          agregarDireccion={agregarDireccionHandler}
        />
      )}
      {mostrarEditarDireccionModal && (
        <EditarDireccionModal
          modalData={editarData.current}
          handleClose={e => setMostrarEditarDireccionModal(false)}
          show={mostrarEditarDireccionModal}
          actualizarDireccion={actualizarDireccionHandler}
        />
      )}
    </>
  )
}

export default React.memo(DireccionesSection)
